import gql from 'graphql-tag';

// Query used to get the list of gratuity entry options.
export const getGratuityEntryOptionEnum = gql`
	query {
		__type(name: "GratuityEntryOption") {
			enumValues {
				name
				description
			}
		}
	}
`;

export default { getGratuityEntryOptionEnum };
